import { GQLStackedPillsFragment } from '@theprintbar/graphql';
import { BrandColours, cn, hexToRGBAString } from '@theprintbar/shared';
import { Container, RichText } from '@theprintbar/ui';

interface StepStacksProps {
	content: GQLStackedPillsFragment;
}

export function StackedPills({ content }: StepStacksProps) {
	if (!content) return null;
	return (
		<div className="flex w-full h-full px-4 lg:px-8 gap-5 flex-col">
			<div className="hidden lg:grid lg:grid-cols-2">
				<div>
					<h2 className="text-2xl lg:text-[32px] font-light">{content.stackedPillsLeftTitle}</h2>
					{content.stackedPillsLeftText && <p className="text-sm">{content.stackedPillsLeftText}</p>}
				</div>
				<div>
					<h2 className="text-2xl lg:text-[32px] font-light">{content.stackedPillsRightTitle}</h2>
					{content.stackedPillsRightText && <p className="text-sm">{content.stackedPillsLeftText}</p>}
				</div>
			</div>
			<div className="flex lg:flex-row flex-col gap-3 lg:gap-8">
				<div className="w-full">
					{content.stackedPillsLeftTitle && (
						<h2 className="lg:hidden text-2xl lg:text-[32px] font-light mb-5">{content.stackedPillsLeftTitle}</h2>
					)}
					<div className="space-y-3">
						{content.stackedPillsLeft?.structure?.map((data, i) =>
							!!data?.title || !!data?.text?.content ? (
								<div
									key={i}
									className={cn('flex items-center justify-between w-full rounded-[20px] py-2.5 px-8 border border-blue')}
									style={{
										backgroundColor:
											hexToRGBAString(content.stackedPillsLeftColour, (i + 1) * 0.1) || BrandColours.Blue,
									}}
								>
									<RichText
										className="font-display font-light text-base lg:text-xl text-left"
										content={data.text?.content}
									/>
									<h2 className="font-gravity font-black text-3xl lg:text-4xl">{data?.title}</h2>
								</div>
							) : null,
						)}
					</div>
				</div>
				<div className="w-full">
					{content.stackedPillsRightTitle && (
						<h2 className="lg:hidden text-2xl lg:text-[32px] font-light mt-16 mb-5">{content.stackedPillsRightTitle}</h2>
					)}
					<div className="space-y-3">
						{content.stackedPillsRight?.structure?.map((data, i) =>
							!!data?.title || !!data?.text?.content ? (
								<div
									key={i}
									className={cn('flex items-center justify-between w-full rounded-[20px] py-2.5 px-8 border border-blue')}
									style={{
										backgroundColor:
											hexToRGBAString(content.stackedPillsRightColour, (i + 1) * 0.1) || BrandColours.Blue,
									}}
								>
									<RichText
										className="font-display font-light text-base lg:text-xl text-left"
										content={data.text?.content}
									/>
									<h2 className="font-gravity font-black text-3xl lg:text-4xl uppercase">{data.title}</h2>
								</div>
							) : null,
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
